import _ from "lodash";
const initialState = {};

const showProjectContextMenuReducer = (state = initialState, action) => {
  if (action.type === "TOGGLE_SHOW_PROJECT_CONTEXT_MENU") {
    const projectid = action.payload.projectId;
    const activeProjectId = Object.keys(state).filter(
      (projectId) => state[projectId] === true
    );
    const statecopy = _.cloneDeep(state);
    if (!statecopy[projectid]) {
      if (activeProjectId[0]) {
        statecopy[activeProjectId] = false;
        statecopy[projectid] = true;
      } else {
        statecopy[projectid] = true;
      }
      return statecopy;
    } else {
      if (activeProjectId[0] === projectid) {
        statecopy[projectid] = false;
        return statecopy;
      }
    }
  }
  return state;
};

export default showProjectContextMenuReducer;
